import axios from "axios";
import {BASE_PATH} from "../services/api";

export const getProductsByStore = async (store_code) => {
    return axios.get(BASE_PATH + "/admin/get-products-by-store/" + store_code, {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    });
}